import amplitude, { AmplitudeClient } from 'amplitude-js';

export const initAmplitude = () => {
  if (process.env['NODE_ENV'] === 'development') {
    return amplitude
      .getInstance()
      .init(process.env.REACT_APP_AMPLITUDE_DEV_KEY);
  } else {
    return amplitude
      .getInstance()
      .init(process.env.REACT_APP_AMPLITUDE_PROD_KEY);
  }
};


export const setAmplitudeVersion = (version) => {
  amplitude.getInstance().setVersionName(version);
};

export const setAmplitudeUserDevice = (installationToken) => {
  amplitude.getInstance().setDeviceId(installationToken);
};

export const setAmplitudeUserId = (userId) => {
  amplitude.getInstance().setUserId(userId);
};

export const setAmplitudeUserProperties = (properties) => {
  amplitude.getInstance().setUserProperties(properties);
};

export const sendAmplitudeData = (eventType, eventProperties) => {
  amplitude.getInstance().logEvent(eventType, eventProperties);
};
